import { SVGProps } from 'react';

const Upload = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 3v12M7 8l5-5 5 5m4 7v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"
    />
  </svg>
);
export default Upload;
